import { useEffect } from 'react'
import { Dialogs, useDialogs } from '../../sharedComponents/src/Contexts/DialogsContext'
import { useHeaderButtons } from '../../sharedComponents/src/Contexts/HeaderButtonsContext'
import { useStoreActions, useStoreState } from '../../store/hooks'
import { MissionsButton } from './MissionButton'
import { MissionCompletePopup } from './MissionCompletePopup'

export const MissionService = () => {
    const { registerDialog, unregisterDialog } = useDialogs()
    const userData = useStoreState((state) => state.userData)
    const getMissions = useStoreActions((state) => state.missionsService.getMissions)
    const { registerButton, unregisterButton } = useHeaderButtons()
    const completedMission = useStoreState((state) => state.missionsService.completedMission)

    useEffect(() => {
        if (completedMission) {
            // Logic to show the popup can be added here if needed
            registerDialog(Dialogs.MISSION_COMPLETE, <MissionCompletePopup />)
        }
        return () => {
            // Cleanup if necessary when completedMission changes or component unmounts
            unregisterDialog(Dialogs.MISSION_COMPLETE)
        }
    }, [completedMission])

    useEffect(() => {
        userData.userData?.id && getMissions()
    }, [userData.userData?.id, userData.userData?.user_name])

    useEffect(() => {
        registerButton('missionsNavigation', <MissionsButton />)
        return () => {
            unregisterButton('missionsNavigation')
        }
    }, [])

    return null

    // return <ThemeProvider theme={theme}><MissionCompletePopup /></ThemeProvider>
}
